const Badge = ({ variant, className = '', children }) => {
  const bgClassName =
    variant === 'success'
      ? 'bg-success-200'
      : variant === 'flagged'
        ? 'bg-[#FFD042]'
        : 'bg-error-200'

  return (
    <div className={`${bgClassName} ${className} rounded-lg py-[10px] !px-4 text-white`}>
      {children}
    </div>
  )
}

export default Badge
